module.exports = __webpack_public_path__ + "static/media/user-friendly-interface.52a957b8.svg";